import { render } from "./UncategorizedChatView.vue?vue&type=template&id=482a5722"
import script from "./UncategorizedChatView.vue?vue&type=script&lang=js"
export * from "./UncategorizedChatView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__